<template>
  <div
    class="m-progress"
    :style="{backgroundColor:trackColor,width:strokeWidth,height:strokeHeight}"
  >
    <div
      class="m-progress-bar"
      :style="{backgroundColor:color,left:((percentage/2).toFixed(0))+'%'}"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'MProgress',
  props: {
    strokeWidth: {
      type: String,
      default: '50px'
    },
    percentage: {
      type: Number,
      default: 0
    },
    strokeHeight: {
      type: String,
      default: '5px'
    },
    color: {
      type: String,
      default: '#3770d3'
    },
    trackColor: {
      type: String,
      default: '#eee'
    }
  }
}
</script>
<style scoped lang="scss">
.m-progress {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  .m-progress-bar {
    width: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    border-radius: 20px;
  }
}
</style>
